import axios from "axios";
import { Message, Loading, MessageBox } from "element-ui";
import Token from "./token";

const ConfigBaseURL = process.env.NODE_ENV === "development" ? "/api/pv-helper" : "/prod"; //默认路径，这里也可以使用env来判断环境
let loadingInstance = null; //这里是loading
//使用create方法创建axios实例
export const axiosInstance = axios.create({
  timeout: 100000000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: "post",
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(config => {
  //请求头设置
  config.headers.Authorization = Token.get();

  loadingInstance = Loading.service({
    lock: true,
    text: "loading...",
    background: "rgba(0,0,0,.35)"
  });

  return config;
});
// 添加响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    loadingInstance.close();
    if (response.data instanceof Blob) {
      let fileName = window.decodeURI(
        response.headers["content-disposition"].split("=")[1]
      );
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/octet-stream" })
      );
      link.target = "_blank";
      link.download = fileName;
      link.click();
      return response;
    }
    // console.log('response:', response)
    if (response.data.code !== 200 && response.data.msg) {
      if (response.data.code === 401) {
        Token.remove();
        location.href = "/#/signin";
      } else {
        Message.error(response.data.msg);
      }
    }
    return response.data || {};
  },
  error => {
    if (error.response && error.response.status === 401) {
      MessageBox.alert(
        "登陆状态已过期，您可以继续留在该页面，或者重新登录",
        "系统提示",
        {
          confirmButtonText: "重新登录",
          type: "warning",
          callback: action => {
            Token.remove();
            location.href = "/#/signin";
          }
        }
      );
    } else {
      Message({
        message: "网络错误: " + error.message,
        type: "error",
        duration: 3 * 1000
      });
    }
    loadingInstance.close();

    return Promise.reject(error);
  }
);




export default function ajax(
  method,
  url,
  params = {},
  contentType = "application/json",
  options = {}
) {
  const configs = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    "Content-Type": contentType
  };

  method = method.toLocaleLowerCase();
  if (method === "get") {
    configs.params = params;
  } else {
    configs.data = params;
  }
  // if(data) {
  //   configs.params = data
  // }
   return axiosInstance.request(configs);
}



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js